import { render } from "./S175133.vue?vue&type=template&id=52732c04"
const script = {}
script.render = render

export default script